import { defineComponent, ref, computed, toRef, resolveComponent, openBlock, createElementBlock, normalizeClass, createVNode, mergeProps, withCtx, renderSlot, normalizeProps, guardReactiveProps } from 'vue';
import { t as te } from '../OrAutocompleteV3-508d99c0.js';
import { OrFilterPopoverV3 as script$1 } from '../or-filter-popover-v3/index.js';
import { OrFilterTriggerV3 as script$2 } from '../or-filter-trigger-v3/index.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-46210775.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';
import '../or-modal-v3/index.js';

const Filter = [];

var script = defineComponent({
  name: 'OrFilter',
  components: {
    OrFilterPopover: script$1,
    OrFilterTrigger: script$2
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    triggerProps: {
      type: Object,
      default: () => ({})
    },
    popoverProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:state', 'open', 'close', 'apply', 'reset'],
  expose: ['root', 'state', 'open', 'close', 'toggle'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-filter-v3', ...Filter]);
    const trigger = ref();
    const triggerRoot = computed(() => {
      var _a;
      return (_a = trigger.value) === null || _a === void 0 ? void 0 : _a.root;
    });
    const popover = ref();
    // State
    const {
      state,
      open,
      close,
      toggle
    } = te(toRef(props, 'isOpen'), context.emit);
    // Methods
    function apply() {
      context.emit('apply');
    }
    function reset() {
      context.emit('reset');
    }
    return {
      root,
      rootStyles,
      trigger,
      triggerRoot,
      popover,
      state,
      open,
      close,
      toggle,
      apply,
      reset
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrFilterTrigger = resolveComponent("OrFilterTrigger");
  const _component_OrFilterPopover = resolveComponent("OrFilterPopover");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createVNode(_component_OrFilterTrigger, mergeProps({
    ref: 'trigger',
    "is-open": _ctx.state === 'open'
  }, _ctx.triggerProps, {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.toggle()),
    onReset: _cache[1] || (_cache[1] = $event => _ctx.reset())
  }), null, 16 /* FULL_PROPS */, ["is-open"]), createVNode(_component_OrFilterPopover, mergeProps({
    ref: 'popover',
    "is-open": _ctx.state === 'open',
    trigger: _ctx.triggerRoot
  }, _ctx.popoverProps, {
    "onUpdate:state": _cache[2] || (_cache[2] = $event => $event === 'open' ? _ctx.open() : _ctx.close()),
    onApply: _cache[3] || (_cache[3] = $event => _ctx.apply()),
    onReset: _cache[4] || (_cache[4] = $event => _ctx.reset())
  }), {
    actions: withCtx(props => [renderSlot(_ctx.$slots, 'actions', normalizeProps(guardReactiveProps(props)))]),
    default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["is-open", "trigger"])], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-filter-v3/OrFilter.vue";

export { script as OrFilterV3 };
